import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import './featureGridSection.css';

const FeatureGridSection = ({ data }) => {
  const {
    mainTitle,
    items = [],
    title,
    subtitle,
    ctaText,
    backgroundImage
  } = data;

  return (
    <section className="feature-section">
      <div className="container feature-section__inner">
        {mainTitle && (
          <h2 className="feature-section__main-title">
            {mainTitle}
          </h2>
        )}
        <div className="row feature-section__grid justify-content-center">
          {items.map((item, idx) => (
            <div key={idx} className="col-12 col-md-4 feature-section__item">
              <span className="feature-section__number">
                {item.number}
              </span>
              <h3 className="feature-section__heading casper-normal">
                {item.heading}
              </h3>
            </div>
          ))}
        </div>
      </div>
      <div
        className="feature-section__cta container-fluid"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="container feature-section__cta-content-wrapper">
          {title && (
            <div className="feature-section__cta-title">
              <span className="feature-section__title">
                {title}
              </span>
            </div>
          )}
          {subtitle && (
            <p className="feature-section__subtitle casper-normal">
              {subtitle}
            </p>
          )}
          <div className="feature-section__cta-content">
            <FaPhoneAlt className="feature-section__cta-icon" />
            <p className="feature-section__cta-text line-height-clss">
              {ctaText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureGridSection;
